import * as React from 'react';
import { Canceler } from 'axios';

import {
  ITargetCheckProps,
  ITargetCheckState,
  IOptions,
  IFilterValues,
  ILink,
} from './types';
import { Icons, Pagination } from 'src/components';
import { SingleLink } from './components/SingleLink';
import Filters from './components/Filters';
import API from 'src/services/api';
import Search from './components/Search';
import { scrollToElement } from 'src/services/scrolling';
import { defaultFilters } from './services/defaultFilters';
import Container from 'src/components/Container';

class TargetCheck extends React.Component<
  ITargetCheckProps,
  ITargetCheckState
> {
  reqCanceler: Canceler | null = null;
  filters: IOptions = defaultFilters;
  state: ITargetCheckState = {
    currentPage: 1,
    pageCount: 1,
    isLoading: true,
    isFiltering: false,
    links: [],
  };

  containerRef: React.RefObject<HTMLDivElement> = React.createRef();

  async fetchLinks() {
    if (this.reqCanceler) {
      this.reqCanceler();
    }
    const { getData, cancel } = API.TARGET_CHECK.getDashboard(this.filters);
    this.reqCanceler = cancel;
    const data = await getData();
    this.reqCanceler = null;
    return data;
  }

  updateLink = (link: ILink) => {
    this.setState((state) => {
      const existingLinkIndex = state.links.findIndex(
        (el) => el.createdLinkId === link.createdLinkId
      );
      if (existingLinkIndex !== undefined) {
        return {
          ...state,
          links: [
            ...state.links.slice(0, existingLinkIndex),
            link,
            ...state.links.slice(existingLinkIndex + 1),
          ],
        };
      }
      return state;
    });
  };

  async componentDidMount() {
    const { links, pageCount } = await this.fetchLinks();
    this.setState({
      links,
      pageCount,
      isLoading: false,
    });
  }
  componentWillUnmount() {
    if (this.reqCanceler) {
      this.reqCanceler();
    }
  }

  filterLinks = async (dateFilters: IFilterValues) => {
    this.filters = {
      ...this.filters,
      ...dateFilters,
    };
    this.scrollToListTop();
    this.setState({ isFiltering: true });
    const { links } = await this.fetchLinks();
    this.setState({ links, currentPage: 1, isFiltering: false });
  };

  filterWithSearch = async (searchTerm: string) => {
    this.filters.searchTerm = searchTerm;
    this.scrollToListTop();
    this.setState({ isFiltering: true });
    const { links } = await this.fetchLinks();
    this.setState({ links, isFiltering: false });
  };

  loadPage = async (page: number) => {
    if (this.state.currentPage === page) {
      return;
    }
    this.filters.page = page;
    this.scrollToListTop();
    this.setState({ currentPage: page, isFiltering: true });
    const { links } = await this.fetchLinks();
    this.setState({ links, isFiltering: false });
  };

  scrollToListTop = () => {
    if (this.containerRef.current) {
      scrollToElement(this.containerRef.current);
    }
  };

  renderLoading() {
    return (
      <div className="mt-12">
        {Array.from({ length: 10 }).map((_, index) => (
          <div
            key={index}
            className="loader bg-grey rounded mb-10 flex-1 h-32"
          />
        ))}
      </div>
    );
  }

  renderLinks() {
    const { links, isFiltering, currentPage, pageCount } = this.state;
    return (
      <>
        <div className="relative">
          <Pagination
            current={currentPage}
            count={pageCount}
            onChange={this.loadPage}
            className="mb-4"
          />
        </div>
        {links.map((link) => (
          <SingleLink
            key={link.createdLinkId}
            link={link}
            isLoading={isFiltering}
            onRun={this.updateLink}
          />
        ))}
        <Pagination
          current={currentPage}
          count={pageCount}
          onChange={this.loadPage}
        />
      </>
    );
  }

  render() {
    const { isLoading, isFiltering, links } = this.state;
    return (
      <Container ref={this.containerRef}>
        <Search onSubmit={this.filterWithSearch} isSearching={isFiltering} />

        <div className="flex">
          <Filters onSubmit={this.filterLinks} />

          <div className="flex-1 pl-16">
            {isLoading ? (
              this.renderLoading()
            ) : links.length > 0 ? (
              this.renderLinks()
            ) : (
              <div className="text-lg text-center my-8">
                <h2 className="my-8">
                  <Icons.Circle
                    character="!"
                    color="secondary"
                    bgFill={true}
                    className="mb-1 mr-2"
                  />{' '}
                  No matching links found
                </h2>
                <p>Please change the active filters and try again</p>
              </div>
            )}
          </div>
        </div>
      </Container>
    );
  }
}

export default TargetCheck;



// WEBPACK FOOTER //
// ./src/views/TargetCheck/TargetCheck.tsx